<template>
  <div id="dashboard">
    <filters
      :monthRange="true"
      :region="true"
      :comparisonYear="true"
      :dataSource="$t('filter.sourceHesta')"
      :selectedyear="this.selectedYear"
      @refresh="setParams"
    />
    <loading v-if="loading" />
    <b-row v-else>
      <b-col>
        <LevelTableCard
          :period_info="$t('dashboard.region.caption')"
          v-if="this.marketsTable.data"
          :title="'Märkte'"
          :table="this.marketsTable"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DashboardMixins from "@/mixins/api/dashboard";
import LevelTableCard from "@/components/dashboard/LevelTableCard";

export default {
  name: "Markets",
  mixins: [DashboardMixins],
  components: {
    LevelTableCard,
  },
  data() {
    return {
      marketsTable: {
        data: null,
        header: [
          this.$t("dashboard.provenance.countries"),
          this.$t("dashboard.kpi.arrivals.header"),
          this.$t("dashboard.kpi.overnights.header"),
          this.$t("legends.evoPercent"),
          this.$t("legends.evoReal"),
          this.$t("legends.marketShare"),
          this.$t("legends.marketShare_foreigners"),
          this.$t("dashboard.kpi.stay.header"),
        ],
      },
    };
  },
  methods: {
    setParams(newParams) {
      this.params = newParams;
      this.refreshMarkets();
    },
  },
};
</script>